module.exports = __webpack_public_path__ + "static/img/2_3_2.34c2adc3.jpg";